// ResetPasswordPage — 비밀번호 재설정(메일 토큰 링크).
import { useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import { authAPI } from '../api/client';
import useIsMobile from '../hooks/useIsMobile';
import { COLORS } from '../utils/uiStyles';

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const token = searchParams.get('token');
  const mobile = useIsMobile();
  const S = styles(mobile);
  const passwordMismatch = Boolean(password2 && password !== password2);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== password2) { setError('비밀번호가 일치하지 않습니다.'); return; }
    setError(''); setLoading(true);
    try {
      const res = await authAPI.resetPassword({ token, password });
      setMessage(res.data.message);
      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      setError(err.response?.data?.detail || '재설정에 실패했습니다.');
    } finally { setLoading(false); }
  };

  if (!token) return (
    <div style={S.wrap}><div style={S.card}><p style={S.err} role="alert">유효하지 않은 링크입니다.</p><p style={S.link}><Link to="/login">로그인으로 돌아가기</Link></p></div></div>
  );

  return (
    <div style={S.wrap}>
      <div style={S.card}>
        <h2 style={S.title}>비밀번호 재설정</h2>
        <p style={S.desc}>새 비밀번호를 입력하면 기존 비밀번호는 더 이상 사용할 수 없습니다.</p>
        {message ? (
          <p style={S.ok} role="status">{message} 잠시 후 로그인 화면으로 이동합니다.</p>
        ) : (
          <form onSubmit={handleSubmit} style={S.form}>
            <label style={S.label}>새 비밀번호</label>
            <input style={S.input} type="password" placeholder="8자 이상" autoComplete="new-password" minLength={8}
              value={password} onChange={(e) => setPassword(e.target.value)} required />
            <label style={S.label}>새 비밀번호 확인</label>
            <input style={S.input} type="password" placeholder="새 비밀번호를 다시 입력" autoComplete="new-password" minLength={8}
              value={password2} onChange={(e) => setPassword2(e.target.value)} required />
            {passwordMismatch && <p style={S.hintErr}>새 비밀번호가 일치하지 않습니다.</p>}
            {error && <p style={S.err} role="alert">{error}</p>}
            <button style={{ ...S.btn, ...((loading || passwordMismatch) ? S.btnDisabled : {}) }} type="submit" disabled={loading || passwordMismatch}>
              {loading ? '처리 중...' : '비밀번호 변경'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

const styles = (mobile) => ({
  wrap: { display:'flex', justifyContent:'center', alignItems:'center', minHeight:'var(--gw-app-h, 100dvh)', background:'#f5f5f5', boxSizing:'border-box', padding: mobile ? '16px' : 0 },
  card: { background:'white', padding: mobile ? '28px 20px' : '40px', borderRadius:'12px', boxShadow: mobile ? 'none' : '0 2px 12px rgba(0,0,0,.1)', width: mobile ? '100%' : '360px', maxWidth: mobile ? '420px' : undefined, boxSizing:'border-box' },
  title: { textAlign:'center', marginBottom:'10px', fontSize:'20px', fontWeight:'700' },
  desc: { fontSize:'13px', color:'#666', margin:'0 0 18px', lineHeight:'1.6', textAlign:'center' },
  form: { display:'flex', flexDirection:'column' },
  label: { fontSize:'12px', color:'#4b5563', fontWeight:700, marginBottom:'6px' },
  input: { width:'100%', padding: mobile ? '13px 14px' : '10px 12px', marginBottom:'12px', border:'1px solid #d1d5db', borderRadius:'6px', fontSize: mobile ? '16px' : '14px', boxSizing:'border-box', minHeight: mobile ? '46px' : '40px', outline:'none' },
  btn: { width:'100%', padding: mobile ? '14px' : '12px', minHeight: mobile ? '48px' : '42px', background:COLORS.primary, color:'white', border:'none', borderRadius:'6px', fontSize:'15px', fontWeight:700, cursor:'pointer' },
  btnDisabled: { background:COLORS.border, color:COLORS.textMuted, cursor:'not-allowed' },
  err: { color:'#b91c1c', background:'#fef2f2', border:'1px solid #fecaca', borderRadius:'8px', padding:'10px 12px', fontSize:'13px', margin:'0 0 12px', lineHeight:1.5, textAlign:'center' },
  hintErr: { color:'#b91c1c', fontSize:'12px', margin:'-4px 0 10px' },
  ok: { color:'#166534', background:'#f0fdf4', border:'1px solid #bbf7d0', borderRadius:'10px', padding:'12px', fontSize:'14px', textAlign:'center', lineHeight:1.6 },
  link: { textAlign:'center', marginTop:'16px', fontSize:'13px' },
});
